import { useEffect } from "react"
import { useStores } from "stores/root-store"
import { storageName } from "shared/constants/storage-constant"
import { Link, useNavigate } from "react-router-dom"
import { rootStore } from "stores/root-store"
import { observer } from "mobx-react-lite"
import CommonPage from "components/common/common-page"
import { formatDisplayDate } from "utils/date-helper"
import DGItemProfileForm from "components/dg-item-profile/dg-item-profile-form"
import { Typography } from "@mui/material"
import { CommonHyperlink } from "components/common-styles"

const DGItemProfile = observer(() => {
  const navigate = useNavigate()
  const { DGItemProfileStore } = useStores()

  useEffect(() => {
    rootStore.setOpenForm(false)
    rootStore.setScreenTitle("DG Item Profile Search")
    DGItemProfileStore.resetData()
    return () => rootStore.setScreenTitle("")
  }, [])

  const handleClickOpen = () => {
    rootStore.setScreenTitle("")
    rootStore.setOpenForm(true)
  }

  const handleClose = () => {
    rootStore.setScreenTitle("DG Item Profile Search")
    DGItemProfileStore.setSelectedId("")
    rootStore.setOpenForm(false)
  }

  const handleSave = () => {
    handleClose()
    if (DGItemProfileStore.searchText) DGItemProfileStore.loadData()
  }

  const handleRowClicked = params => {
    navigate(`/dg-item-profile/${encodeURIComponent(params.row["ID"])}/${encodeURIComponent(params.row["ITEM"])}`)
  }

  const filterData = [
    {
      name: "before_date",
      text: "Before Date",
      checked: true,
    },
    {
      name: "after_date",
      text: "After Date",
      checked: true,
    },
    {
      name: "packing_group",
      text: "Packing Group",
    },
    /*{
      name: "active",
      text: "Active",
    },
    {
      name: "id8000",
      text: "ID 8000",
    },
    {
      name: "marine_pollutant",
      text: "Marine Pollutant",
    },
    {
      name: "personal_care",
      text: "Personal Care",
    },
    {
      name: "lithium_battery",
      text: "Lithium Battery",
    },*/
  ]

  const hiddenColumns = {
    BATTERY_WEIGHT: false,
    FLASHPOINT_DEGC: false,
    LITHIUM_BATTERY: false,
    MARINE_POLLUTANT: false,
    SUBSIDARY_RISK: false,
    PERSONAL_CARE: false,
    EMERGENCY_CONTACT_NAME: false,
    EMERGENCY_CONTACT_PHONE: false,
  }

  const columns = [
    {
      field: "ITEM",
      headerName: "Item",
      minWidth: 200,
      flex: 1,
      renderCell: params => <CommonHyperlink to={`/dg-item-profile/${encodeURIComponent(params.row["ID"])}/${encodeURIComponent(params.row["ITEM"])}`}>{params.value}</CommonHyperlink>,
    },
    {
      field: "CLASS",
      headerName: "Class",
    },
    {
      field: "PACKING_GROUP",
      headerName: "Packing Group",
    },
    {
      field: "UN_NUMBER",
      headerName: "UN Number",
    },
    {
      field: "DG_VOLUME",
      headerName: "DG Volume",
    },
    {
      field: "COMMON_NAME",
      headerName: "Common Name",
      width: 150,
    },
    {
      field: "TECHNICAL_NAME",
      headerName: "Techincal Name",
      width: 150,
    },
    {
      field: "EMERGENCY_CONTACT_NAME",
      headerName: "Contact Name",
      width: 150,
    },
    {
      field: "EMERGENCY_CONTACT_PHONE",
      headerName: "Contact Phone",
      width: 150,
    },
    {
      field: "MSDS_FILE_NAME",
      headerName: "MSDS File Name",
      width: 150,
    },
    {
      field: "MSDS_CREATION_DATE",
      headerName: "MSDS Creation Date",
      renderCell: params => {
        return formatDisplayDate(params.value)
      },
    },
    {
      field: "MSDS_EXPIRY_DATE",
      headerName: "MSDS Expiry Date",
      renderCell: params => {
        return formatDisplayDate(params.value)
      },
    },
    {
      field: "RECEPTACLE_VOLUME",
      headerName: "Receptacle Volume",
      width: 150,
    },
    {
      field: "ID8000",
      headerName: "ID 8000",
      //renderCell: params => <Checkbox defaultChecked={params.value == "Y"} readOnly={true} />,
    },
    {
      field: "BATTERY_WEIGHT",
      headerName: "Battery Weight",
    },
    {
      field: "MARINE_POLLUTANT",
      headerName: "Marine Pollutant",
      //renderCell: params => <Checkbox defaultChecked={params.value == "Y"} readOnly={true} />,
    },
    {
      field: "PERSONAL_CARE",
      headerName: "Personal Care",
      //renderCell: params => <Checkbox defaultChecked={params.value == "Y"} readOnly={true} />,
    },
    {
      field: "FLASHPOINT_DEGC",
      headerName: "Flashpoint DEGC",
    },
    {
      field: "SUBSIDARY_RISK",
      headerName: "Subsidary Risk",
    },
    {
      field: "LITHIUM_BATTERY",
      headerName: "Lithium Battery",
      //renderCell: params => <Checkbox defaultChecked={params.value == "Y"} readOnly={true} />,
    },
    {
      field: "ACTIVE",
      headerName: "Active",
      //renderCell: params => <Checkbox defaultChecked={params.value == "Y"} readOnly={true} />,
    },
  ]

  if (rootStore.openForm) return <DGItemProfileForm onSave={handleSave} onClose={handleClose} />

  return (
    <>
      <CommonPage
        DataStore={DGItemProfileStore}
        filterData={filterData}
        searchPlaceholder={"Search for Item code or name."}
        filterStorageName={storageName.dgItemProfileFilter}
        allowArchivalSearch={false}
        columns={columns}
        hiddenColumns={hiddenColumns}
        gridStorageName={storageName.dgItemProfileColumn}
        searchRequiredWarningMsg="Search for a specific DG Item Profile and select a filter to narrow down your search"
        noDataMsg="Your search returned no results. Please contact ops@estorelogistics.com.au if you believe this error is incorrect."
        exportFileName="Express_DG_Item_Profile"
        handleAddClicked={handleClickOpen}
        handleRowClicked={handleRowClicked}
      />
    </>
  )
})

export default DGItemProfile
